import "../styles/main.scss";
import Card from "./Card.js";
import Creater from "./Creater.js";
export default function App() {
  return (
    <>
      <Card />
      <Creater />
    </>
  );
}
